import ReactGA from 'react-ga4';
import axios from 'axios';

export const formatPrice = price => new Intl.NumberFormat('en-US').format(price);

export const canBeShowed = (user, roles = []) => {
  if (!user || !user.role) return null;
  return roles.includes(user.role);
};

export const gaEvent = (
  category,
  action,
  label,
  value = 0,
  nonInteraction = true,
  transport = 'xhr'
) => {
  ReactGA.event({
    category,
    action,
    label, // optional
    value, // optional, must be a number
    nonInteraction, // optional, true/false
    transport // optional, beacon/xhr/image
  });
};

export const uploadFile = file => {
  return new Promise((resolve, reject) => {
    const fd = new FormData();

    fd.append('name', file.name);
    fd.append('image', file);
    fd.append('folder', 'map-images');

    axios({
      method: 'post',
      url: '/api/upload/image',
      data: fd
    })
      .then(result => {
        if (result.status === 200) {
          const { data } = result;
          if (data.status === 'success') resolve(data.data);
          if (data.status === 'error') reject(data.message);
        } else {
          reject(result.status);
        }
      })
      .catch(reject);
  });
};

export const pluralize = word => {
  if (word.endsWith('y')) {
    return word.slice(0, -1) + 'ies';
  }
  return word + 's';
};
